module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'absolute inset-0 z-50 flex items-center justify-center bg-gray-700 bg-opacity-50': _vm.size !== 'search',
      'absolute inset-0 z-50 flex items-start justify-center pt-16 pl-10 bg-gray-700 bg-opacity-50': _vm.size === 'search'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleBackgroundClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "bg-white slide-top rounded flex flex-column w-full relative",
    class: _vm.sizeClass
  }, [(_vm.title) ? _c('div', {
    staticClass: "text-blueGray-700 select-none flex justify-between py-3.5 px-5 items-center text-base font-semibold"
  }, [_c('div', {
    staticClass: "flex items-center w-full truncate"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sequence_icon),
      expression: "sequence_icon"
    }],
    staticClass: "mr-2"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.genie_icon),
      expression: "genie_icon"
    }],
    staticClass: "mr-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-wand-magic-sparkles text-pinky"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-full truncate font-poppins font-semibold text-lg text-blueGray-800"
  }, [_c('div', {
    staticClass: "truncate w-full flex items-center space-x-3",
    attrs: {
      "title": _vm.title
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isBeta === true) ? _c('div', {
    staticClass: "flex items-center justify-center w-12 h-6 text-xs text-pinky bg-pink-100 rounded-full border border-solid border-pinky text-center font-manrope"
  }, [_vm._v("\n              BETA\n            ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "underline cursor-pointer"
  }, [_vm._v("\n            " + _vm._s(_vm.title_link) + "\n          ")])])]), _vm._v(" "), (_vm.showCloseButton === true) ? _c('button', {
    staticClass: "w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer text-lg flex items-center justify-center hover:text-primary hover:bg-primary-new_light text-blueGray-700",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center justify-center rounded-full h-7 w-7 bg-purple-light"
  }, [_c('img', {
    staticClass: "w-3.5 h-3.5 pl-0.5",
    attrs: {
      "src": "/static/roundtable_icons/sequence_icon.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2ec52da1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plDialog/plDialog.vue
// module id = 1241
// module chunks = 61